//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import './style.scss';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { ReactComponent as ErrorIcon } from '../../assets/images/error.svg';
import girl from '../../assets/images/girl.png';
import { useStore } from 'src/onboarding/store/store';
import { useMutation } from '@tanstack/react-query';
import { FileService } from 'src/onboarding/services/file.service';
import { AiService } from 'src/onboarding/services/ai.service';
import { formatMonth } from 'src/onboarding/helpers/formatMonth';
import Analytics from '@web-solutions/module-analytics';
import { ReactComponent as LoadingIcon } from '../../assets/images/loading-white.svg';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { t } from '@web-solutions/module-localization';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import { getAdjustedDate } from 'src/onboarding/helpers/getAdjustedDate';
import { getEarlyAchievableOffset } from 'src/onboarding/helpers/getEarlyAchievableOffset';
import { getFullMonthName } from 'src/onboarding/helpers/getFullMonthName';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const [ready, setReady] = useState(false);
  const [continueActive, setContinueActive] = useState(false);
  const [showBlur, setShowBlur] = useState(true);
  const [blurAnimated, setBlurAnimated] = useState(false);
  const [textAnimated, setTextAnimated] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [goalActive, setActiveGoal] = useState(false);
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const [showCenter, setShowCenter] = useState(false);
  const [error, setError] = useState(false);
  const setShowPhotoProcessing = useStore((state) => state.setShowPhotoProcessing);
  const photoProcessingUuid = useStore((state) => state.photoProcessingUuid);
  const idealWeight = useStore((state) => state.idealWeight);
  const height = useStore((state) => state.height);
  const gender = useStore((state) => state.gender);
  const when = useStore((state) => state.when);
  const photoError = useStore((state) => state.photoError);
  const setPhotoError = useStore((state) => state.setPhotoError);
  const [girlUrl, setGirlUrl] = useState(girl);
  const generatedPhotoUrl = useStore((state) => state.generatedPhotoUrl);
  const setGeneratedPhotoUrl = useStore((state) => state.setGeneratedPhotoUrl);

  const { value, type } = idealWeight;

  const adjustedDate = getAdjustedDate(when, getEarlyAchievableOffset(when));

  // const { s3BaseUrl } = getEnvUrl();

  useEffect(() => {
    if (!generatedPhotoUrl) {
      onNext();
      return;
    }

    if (photoError) {
      Analytics.trackEvent('photo_error_screen', 'view');
      setError(true);
      return;
    }
    if (!photoProcessingUuid) {
      onNext();
    }

    if (generatedPhotoUrl) {
      setReady(false);
      setIsImageLoaded(true);
      setGirlUrl(generatedPhotoUrl);
      return;
    }
    if (!photoProcessingUuid || photoProcessingUuid === '') return;

    const timeout = setTimeout(() => {
      setError(true);
    }, 10000);

    checkImage();

    return () => clearTimeout(timeout);
  }, [photoProcessingUuid, photoError]);

  useEffect(() => {
    const autoStartTimeout = setTimeout(() => {
      setActiveGoal(true);
      setReady(true);
      Analytics.trackEvent('photo_generated', 'view');
    }, 1500);

    return () => clearTimeout(autoStartTimeout);
  }, []);

  useEffect(() => {
    if (goalActive) {
      setTimeout(() => setShowTop(true), 100); // Верхний текст через 0.5 сек
      setTimeout(() => setShowBottom(true), 1000);
      setTimeout(() => setShowCenter(true), 600); // центральный текст через 1.5 сек

      setTimeout(() => {
        setBlurAnimated(true);
        setTextAnimated(true);
      }, 3000);

      setTimeout(() => {
        setShowBlur(false);
        setContinueActive(true);
        setActiveGoal(false);
      }, 6000);
    }
  }, [goalActive]);

  const checkImage = async (retry = 0) => {
    try {
      existImageQuery.mutate(photoProcessingUuid + '_output.png');
    } catch (err) {
      Analytics.trackEvent('photo_error_screen', 'view');
      setError(true);
      console.error('Error:', err);
    }
  };

  const existImageQuery = useMutation({
    mutationFn: (data) => {
      return FileService.isExist(data);
    },
    onSuccess: (result) => {
      if (result.data && result.data.result) {
        console.log(result.data.result);

        // const newUrl = `${s3BaseUrl}${photoProcessingUuid}_output.png`;

        setGirlUrl(newUrl);
        setGeneratedPhotoUrl(newUrl);
        setPhotoError(false);
        setIsImageLoaded(true);
        setError(false);
      }
    },
    onError: (error) => {
      setPhotoError(true);
      setError(true);
    },
  });

  const handleTryAgain = async () => {
    setError(false);
    setPhotoError(false);

    try {
      // processImageNewBody.mutate({
      //   photoProcessingUuid,
      //   image: `${s3BaseUrl}${photoProcessingUuid}.png`,
      //   gender: gender.toLowerCase(),
      //   weight: Number(idealWeight.value),
      //   height: Number(height.value),
      // });

      // const newUrl = `${s3BaseUrl}${photoProcessingUuid}_output.png`;

      setGirlUrl(newUrl);
      setGeneratedPhotoUrl(newUrl);
      setIsImageLoaded(true);
    } catch (err) {
      Analytics.trackEvent('photo_error_screen', 'view');
      setError(true);
      setPhotoError(true);
    }
  };

  const processImageNewBody = useMutation({
    mutationFn: (data) => {
      return AiService.newBody(data);
    },
    onSuccess: (result) => {
      setError(false);
      setPhotoError(false);
    },
    onError: (error) => {
      setError(true);
      setPhotoError(true);
    },
  });

  const handleResult = () => {
    setActiveGoal(true);
    setReady(true);
  };

  const handleSkip = () => {
    setShowPhotoProcessing(false);
    setError(false);
    onNext();
  };

  return (
    <div className={'ltsv-result_new'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div
        className='content'
        style={{ backgroundImage: `url(${generatedPhotoUrl ? generatedPhotoUrl : girlUrl})` }}
      >
        {showBlur && <div className={`blur ${blurAnimated ? 'animate' : ''}`}></div>}
        {!ready && <Title>{t('onboarding.lts-result.ready')}</Title>}
        {goalActive && (
          <Title className={`animated-text ${textAnimated ? 'fade-out' : ''}`}>
            <span className={`top-text ${showTop ? 'show' : ''}`}>
              <span>{`${value} ${type}`}</span> by
            </span>
            <span className={`center-text ${showCenter ? 'show' : ''}`}>
              {' '}
              {getFullMonthName(adjustedDate.month)}{' '}
            </span>
            <span className={`bottom-text ${showBottom ? 'show' : ''}`}>{adjustedDate.year}</span>
          </Title>
        )}
        <div className={'bottom-blur'}></div>
      </div>
      <div className={'controls'}>
        {/* {!ready &&
          (isImageLoaded ? (
            <button
              onClick={() => {
                Analytics.trackEvent('photo_generated', 'view');
                handleResult();
              }}
            >
              I'm ready!
            </button>
          ) : (
            <button>
              <LoadingIcon width={20} height={20} />
            </button>
          ))} */}
        {continueActive && !showBlur && (
          <Button
            className={'continue-btn'}
            title={t('onboarding.lts-result.continue')}
            onClick={() => {
              Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                page: 'lts-result',
                answer: '',
              });
              setShowPhotoProcessing(false);
              onNext();
            }}
          />
        )}
      </div>

      {error && !isImageLoaded && (
        <div className='error-wrapper'>
          <div className='error'>
            <ErrorIcon />
            <p>{t('onboarding.lts-result.errorTitle')}</p>
            <span>🙄 {t('onboarding.lts-result.errorDescription')}</span>
          </div>

          <div className={'buttons'}>
            <Button
              onClick={() => {
                onNext();
              }}
              title={t('onboarding.lts-result.continue')}
            />
            {/* <button className={'again'} onClick={handleTryAgain}>
              Try Again
            </button>
            <button
              className={'skip'}
              onClick={() => {
                Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                  page: 'lts-result',
                  answer: '',
                });
                handleSkip();
              }}
            >
              Skip
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
}
export default Page;
